export default __webpack_public_path__ + "static/media/4.f540ab07.jpg";